export default [
  {
    path: "/cabinet/tasks",
    name: "user-tasks",
    meta: {
      title: "Список задач",
      authRequired: true,
    },
    component: () => import("@/modules/cabinet/tasks/views/tasks.vue"),
  },
];
